<template>
    <div class="jump-login nav-bar-fixed  bind-user">
        <van-nav-bar title="账号绑定" left-arrow fixed 
        @click-left="back" />
        <van-tabs v-model="tabActive">
                <van-tab class="" title="账号绑定">
                  <div class="jump-login-logo" >
                          <img src="../assets/jumuclogo.png" />
                  </div>
                  <div class="jump-login-body">
                      <van-cell-group>
                          <van-field 
                              v-model="phone" 
                              placeholder="请输入手机号码"
                              >
                            <i class="iconfont icon-icon--" slot="left-icon"></i>
                          </van-field>
                          <van-field
                              v-model="smsCode"
                              placeholder="请输入短信验证码"
                              >
                            <i class="iconfont icon-mima" slot="left-icon"></i>
                              <van-button :disabled="smsBtnDisabled"  slot="button" size="small" type="primary" class="smsBtn" @click="sendCode">
                              {{smsBtnText}}
                                </van-button>
                          </van-field>
                      </van-cell-group>
                      <div class="jump-login-body-foo">
                          <van-button  size="large" @click="bindUser">确 认</van-button>
                      </div>
                  </div>
                </van-tab>
                <van-tab class="" title="注册">
                    <Register />
                </van-tab>
        </van-tabs>
        
    </div>
</template>
<script>
import { NavBar,Cell, CellGroup, Field, Button, Row, Col,Tabs,Tab,Dialog   } from "vant";
import Register from './Register';
export default {
  name: "binduser",
  components: {
    Register,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]:Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tabs.name]:Tabs,
    [Tab.name]:Tab,
    [Dialog.name]:Dialog
  },
  data() {
    return {
      tabActive:0,
      phone: "",
      password: "",
      smsCode: "",
      smsBtnDisabled:false,
      smsBtnText:'获取验证码',
      openId:'',
    };
  },
  methods: {
    back(){
      location.href = "#/login";
    },
    sendCode(){
      let that = this;
       if(this.phone == ""){
        this.$toast('请填写手机号');
      }else{
        this.$api.post(that.jumuc.wx.sendBindSms,{'mobile':that.phone},
        successRes=>{
          that.$toast(successRes.msg);
          if(successRes.success){
            //发送成功
            that.smsBtnDisabled = true;
            that.smsBtnText = '60秒后重新获取';
            let n = 60;
            let timer = setInterval(function(){
              that.smsBtnText = (n--) + '秒后重新获取';
              if(n==0){
                that.smsBtnDisabled = false;
                that.smsBtnText = '获取验证码';
                clearInterval(timer);
              }
            },1000);
          }
        })
      }
    },
    bindUser(){
       let that = this;
       if(this.phone == ""){
        this.$toast('请填写手机号');
      }else if(this.smsCode == ""){
        this.$toast('请填写验证码');
      }else{
        Dialog.confirm({
          title: '提示',
          message: '是否确认绑定微信?'
        }).then(() => {

          this.$api.post(that.jumuc.wx.bindUser,
            { 
              'mobile':that.phone,
              'code':that.smsCode,
              'openId':that.openId
            },
            successRes=>{
              if(successRes.success){
                localStorage.setItem("name",successRes.data.user.userName) //用户名
                localStorage.setItem("mobile",successRes.data.user.mobile) //手机号
                localStorage.setItem("userId",successRes.data.user.id) //用户iduserRole
                localStorage.setItem("userRole",successRes.data.user.userRole) //userRole
                localStorage.setItem("user_type",successRes.data.user.user_type)//user_type
                localStorage.setItem("level",successRes.data.user.level)//level会员等级
                  that.$toast({
                    message:"绑定成功",
                    duration:3000,
                    onClose:function(){
                      that.$router.push({"path": "/home"})
                    }
                  });
              }else{
                that.$toast(successRes.msg);
              }
            })
        }).catch(() => {
        });
      }
    }
  },
  mounted(){
    this.openId = this.$route.query.openId;
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3C6EEB;

.jump-login {
  &-logo {
    padding: 25px 0;
    text-align: center;
    img {
      width: 95px;
    }
  }
  &-body {
    .van-hairline--top-bottom::after {
      border-top: none;
    }
    &-agree{
      .van-cell__title{
        line-height: 35px;
        color: @bule-thame
      }
    }
    .smsBtn {
      background-color: @bule-thame;
      border-radius: 5px;
    }
    &-foo {
      padding: 10px 15px;
      font-size: 14px;

      button {
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
      p {
        color: @bule-thame;
      }
      &-title {
        text-align: center;
        padding: 25px 0;
      }
      h5 {
        display: inline;
        font-size: 14px;
        position: relative;
        color: #ccc;
      }

      h5:before {
        width: 90px;
        height: 1px;
        content: "";
        position: absolute;
        top: 50%;
        left: -100px;
        background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
        background: -moz-linear-gradient(left, #eeeeee, #dddddd);
        background: linear-gradient(left, #eeeeee, #dddddd);
      }

      h5:after {
        width: 90px;
        height: 1px;
        content: "";
        position: absolute;
        top: 50%;
        right: -100px;
        background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
        background: -moz-linear-gradient(left, #eeeeee, #dddddd);
        background: linear-gradient(left, #eeeeee, #dddddd);
      }
      &-btn a{
        font-size: 16px;
        color: @bule-thame;
      }
      &-treaty{
        padding-top: 10px;
        line-height: 30px;
        vertical-align: middle;
        i{
          vertical-align: middle;
        }
        a{
          margin-left:5px;
          color: @bule-thame; 
        }
      }
    }
    &-icon {
      padding-top: 20px;
      i {
        font-size: 48px;
        color: @bule-thame;
      }
    }
  }
}
.nav-bar-fixed.registe{
  padding-top: 0px;
}
</style>
